import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dislike-list',
  templateUrl: './dislike-list.component.html',
  styleUrls: ['./dislike-list.component.css']
})
export class DislikeListComponent implements OnInit {

  listKarma;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() { 

  }
  
  action(list) {
    this.listKarma = list;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/dislike-list/dislike-list.component.ts